import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not auth, obj = auth

  const refreshMe = () => api.get("/auth/me").then((r) => { setUser(r.data); return r.data; });

  useEffect(() => {
    refreshMe().catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    // Fresh workshop login should start with no worker selected.
    if (data.role === "atolye") localStorage.removeItem("acting_usta_id");
    setUser(data);
    return data;
  };
  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    localStorage.removeItem("acting_usta_id");
    setUser(false);
  };

  // Workshop tablet: pick / release the acting worker.
  const selectUsta = async (ustaId) => {
    const prev = localStorage.getItem("acting_usta_id");
    localStorage.setItem("acting_usta_id", ustaId);
    try {
      return await refreshMe();
    } catch (e) {
      // Revert on failure so the tablet doesn't get stuck on a bad selection.
      if (prev) localStorage.setItem("acting_usta_id", prev);
      else localStorage.removeItem("acting_usta_id");
      throw e;
    }
  };
  const clearUsta = async () => {
    localStorage.removeItem("acting_usta_id");
    return refreshMe();
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, selectUsta, clearUsta, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
